import { create } from 'zustand';

/** Whether the keyboard shortcuts dialog is open — set by `?`, the Help menu and the About page. */
export const useShortcutsDialog = create<{ open: boolean }>(() => ({ open: false }));
